import React from "react";
import { Check } from "lucide-react";
import { whyUs, IMG, site } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";

const About = () => {
  return (
    <div>
      <Seo
        title="About Premier Granite LLC"
        description="Premier Granite LLC is a Texas stone fabrication and installation company serving residential and commercial projects with quality workmanship and attention to detail."
        path="/about"
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "About", path: "/about" }])}
      />
      <PageHero
        eyebrow="About"
        title="Built Around Craftsmanship"
        subtitle="Quality workmanship, careful attention to detail and stone surfaces built to complement the spaces where people live and work."
        image={IMG.slabs}
        testid="about-hero"
      />

      <section className="section bg-white">
        <div className="container-custom grid lg:grid-cols-2 gap-14 items-center">
          <div className="img-zoom rounded-lg overflow-hidden h-96">
            <img src={IMG.kitchenDining} alt="Premier Granite craftsmanship" className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div>
            <p className="text-lg text-neutral-700 leading-relaxed mb-5">
              Premier Granite LLC is a Texas stone fabrication and installation company serving residential and commercial projects.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-5">
              Our focus is straightforward: quality workmanship, careful attention to detail and stone surfaces built to complement the spaces where people live and work.
            </p>
            <p className="text-neutral-600 leading-relaxed">
              From kitchen countertops and islands to bathroom vanities and commercial surfaces, we bring precision fabrication and careful installation to every project across the {site.serviceArea}.
            </p>
          </div>
        </div>
      </section>

      <section className="section bg-[#FAFAF9] border-y border-neutral-200">
        <div className="container-custom">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyUs.map((w) => (
              <div key={w.title}>
                <div className="w-11 h-11 mb-4 rounded-full bg-[#1A3D84] flex items-center justify-center">
                  <Check size={18} className="text-white" />
                </div>
                <h3 className="text-xl mb-2">{w.title}</h3>
                <p className="text-neutral-600 text-sm">{w.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default About;
